import { __awaiter, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DeliveryOptionsEnum } from '@as-react/common-types';
import { Box, CollapsibleContent, RadioButton, SelectionCard, TextAlpha, useCollapsible, } from '@yonderland/andes-react';
import { convertToCurrencySymbol } from '../../../../util/CurrencyUtil';
import { useTranslation } from 'react-i18next';
import AsNumeral from '../../../../vendors/asNumeral';
import { useEffect, useRef } from 'react';
import { CollectHQContainer } from '../CollectHQContainer';
import { analyticsActions } from '../../../../redux/analytics/actions/AnalyticsActions.creators';
import { useDispatch } from 'react-redux';
import { basketActions } from '../../../../redux/basket/actions/BasketActions.creators';
import { ScrollUtil } from '../../../../util/ScrollUtil';
import { mimicDelay } from '../../../../util/GeneralUtil';
import { DELAY } from '../../../../constants/GeneralConstants';
import { PickupPointContainer } from '../pickup-point/PickupPointContainer';
import { HomeDeliveryContainer } from '../home-delivery/HomeDeliveryContainer';
import { CollectStoreContainer } from '../collect-store/CollectStoreContainer';
import { useDeliveryState } from '../../../../context/CheckoutDeliveryContext';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { FormField } from '../../../form/FormField';
import { useFormContext } from 'react-hook-form';
export const DeliveryOption = ({ disabled, option, checked, subtitle, exclusionText }) => {
    const { t } = useTranslation(I18N_NAMESPACES.buy);
    const { displayName, name, priceDelivery, priceCurrency } = option;
    const { contentProps, handleToggle } = useCollapsible();
    const [{ activeDeliveryOption, info }, dispatch] = useDeliveryState();
    const dispatchRedux = useDispatch();
    const selectionCardRef = useRef(null);
    const { setValue } = useFormContext();
    useEffect(() => {
        const scrollToCard = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!selectionCardRef.current)
                return;
            yield mimicDelay(DELAY.DELAY_250);
            ScrollUtil.scrollToPosition(selectionCardRef.current.offsetTop - window.innerHeight / 3);
        });
        if (checked) {
            scrollToCard();
        }
    }, [checked]);
    const getDeliveryPrice = () => !priceDelivery
        ? t('buy.delivery.price.free')
        : `${convertToCurrencySymbol(priceCurrency)}${AsNumeral.formatAsCurrency(priceDelivery)}`;
    const getContent = (option) => {
        switch (option.name) {
            case DeliveryOptionsEnum.COLLECT_HQ:
                return _jsx(CollectHQContainer, {});
            case DeliveryOptionsEnum.COLLECT_STORE:
                return _jsx(CollectStoreContainer, {});
            case DeliveryOptionsEnum.HOME_DELIVERY:
            case DeliveryOptionsEnum.NAMED_DAY:
            case DeliveryOptionsEnum.NEXT_DAY:
                return _jsx(HomeDeliveryContainer, {});
            case DeliveryOptionsEnum.PICKUP_POINT:
                return _jsx(PickupPointContainer, {});
            default:
                return _jsx("h2", { children: "not found" });
        }
    };
    const onChange = (name) => {
        if (checked || disabled) {
            return;
        }
        !checked && handleToggle();
        dispatch({ type: 'set_active_delivery_option', payload: option });
        setValue('chosenDeliveryOption', name);
        dispatchRedux(analyticsActions.deliveryStepOption(name));
        dispatchRedux(basketActions.createGetAction());
    };
    const showSubtitle = (option) => subtitle &&
        (!activeDeliveryOption ||
            (activeDeliveryOption &&
                !(activeDeliveryOption.name === option.name && (option === null || option === void 0 ? void 0 : option.name) === DeliveryOptionsEnum.COLLECT_STORE)));
    return (_jsxs(SelectionCard, { testId: `delivery_option_${option.name.toLowerCase()}`, innerRef: selectionCardRef, onClick: () => onChange(name), state: disabled ? 'disabled' : checked ? 'active' : 'resting', children: [_jsx(SelectionCard.Cell, { section: "media", cellProps: { align: 'stretch' }, children: _jsx(Box, { paddingBlockStart: "0.5", children: _jsx(FormField, { name: "chosenDeliveryOption", children: (_a) => {
                            var _b = _a.fieldProps, { ref } = _b, options = __rest(_b, ["ref"]);
                            return (_jsx(RadioButton, Object.assign({}, options, { id: name, name: "checkout-delivery-options", value: name, checked: checked, disabled: disabled, onChange: () => onChange(name) })));
                        } }) }) }), _jsxs(SelectionCard.Cell, { section: "header", children: [_jsx(TextAlpha, { variant: "titleS", color: disabled ? 'subtle' : undefined, children: displayName }), showSubtitle(option) && _jsx(TextAlpha, { color: "success", children: subtitle })] }), _jsx(SelectionCard.Cell, { section: "tag", children: _jsx(TextAlpha, { color: disabled ? 'subtle' : !priceDelivery ? 'success' : 'neutral', children: getDeliveryPrice() }) }), exclusionText && (_jsx(SelectionCard.Cell, { section: "content", cellProps: { offset: 2 }, children: _jsx(TextAlpha, { children: exclusionText }) })), _jsx(SelectionCard.Cell, { section: "content", children: _jsx(CollapsibleContent, Object.assign({}, contentProps, { isOpen: checked, children: !!info && getContent(option) })) })] }));
};
